import { appAssetsCdnUrl } from '~/constants/environment';
import optimizeImage, { type Options } from '~/utilities/optimizeImage';

const commonOptions: Options = {
  format: 'auto',
  optimize: 'high',
  quality: 90
};

export const optimizedMobileImageUrl = optimizeImage(
  `${appAssetsCdnUrl}/images/shaqvana/shaqvana-hero-bg-mobile.jpg`,
  { ...commonOptions, height: 407 }
);

export const optimizedTabletImageUrl = optimizeImage(
  `${appAssetsCdnUrl}/images/shaqvana/shaqvana-hero-bg-tablet.jpg`,
  { ...commonOptions, height: 462 }
);

export const optimizedDesktopImageUrl = optimizeImage(
  `${appAssetsCdnUrl}/images/shaqvana/shaqvana-hero-bg-desktop.jpg`,
  { ...commonOptions, height: 516 }
);
